const exam = {
  namespaced: true,
  state: {
    currentExamForm: {},
  },
  mutations: {
    assign(state, value) {
      Object.assign(state, value);
    },
  },
  actions: {
    assign({ commit }, value) {
      return commit('assign', value);
    },
  },
};

export default exam;
